export default __webpack_public_path__ + "static/media/photo13.f1672d61.jpg";